import React, { useState } from 'react';
import { FCW } from '../../types.ts';
import { ConfigLayer, ConfigLayers } from '@/eventConfig/types.ts';
import { Layer } from './LayerContext.tsx';
import { useEventConfig } from '@/eventConfig/useEventConfig.ts';
import { useNavigation } from '@/navigation/NavigationContex.ts';

type LayerState = 'visible' | 'closed' | 'closing';
export type LayerOpenProps = Partial<ConfigLayer> & { ref?: string };

export interface LayerApi {
  layerState: 'visible' | 'closed' | 'closing';
  closeLayer: () => void;
  content: ConfigLayer | null;
  showLayer: (props: LayerOpenProps) => void;
}

export const LayerProvider: FCW = ({ children }) => {
  const { eventConfig } = useEventConfig();
  const { currentSlide } = useNavigation();

  const [layerState, setLayerState] = useState<LayerState>('closed');
  const [content, setContent] = useState<ConfigLayer | null>(null);

  const closeLayer = () => {
    if (content?.closeable) {
      // if closeAble
      setLayerState('closing');

      setTimeout(() => {
        if (content?.onClose) {
          content.onClose();
        }
        setLayerState('closed');
        setContent(null);
      }, 600);
    }
  };

  const openLayer = () => {
    setLayerState('visible');
  };

  const showLayer = ({ ref, ...props }: LayerOpenProps) => {
    let config = { ...props };

    if (ref && ref.indexOf('@') === 0) {
      const reference = ref.slice(1) as ConfigLayers;
      config = {
        ...eventConfig?.layers[reference],
        ...props,
      };
    }

    const why = eventConfig!.translations.why;

    setContent({
      text: config.text,
      title: config.title || currentSlide?.infoLabel || why,
      icon: config.icon || currentSlide?.infoIcon || 'info',
      closeable: config.closeable !== false,
      buttons: config.buttons,
      onClose: config.onClose || undefined,
    });

    if (config.text !== undefined) {
      openLayer();
    } else {
      closeLayer();
    }
  };

  return (
    <Layer.Provider
      value={{
        layerState,
        closeLayer,
        content,
        showLayer,
      }}
    >
      {children}
    </Layer.Provider>
  );
};
